module.exports = require("cli-width");


//////////////////
// WEBPACK FOOTER
// external "cli-width"
// module id = 71
// module chunks = 0